import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Input,
  InputArray,
  MultilpleSelectAutoComplete,
  SelectUsageLimitType,
  SelectBoolean,
} from "../../../FormControls";
import { BoundTo, FormMode } from "../../../../constant";
import FeaturesModal from "../features-modal";
import { GetFeatures } from "../action";

const ProductInfo = ({
  disabled,
  onEdit,
  canDefineLicense,
  modalMode,
  ...props
}) => {
  const [showNewFeatureModal, setShowNewFeatureModal] = useState(false);
  const [featureOptions, setFeatureOptions] = useState([]);

  useEffect(() => {
    props.GetFeatures();
  }, []);

  useEffect(() => {
    const newFeatureOptions = props.features.map((feature) => {
      return {
        id: feature.external_feature_id,
        label: `${feature.external_feature_id} - ${feature.description}`,
      };
    });
    setFeatureOptions(newFeatureOptions);
  }, [props.features]);

  const setBoundToValue = (e, setFieldValue) => {
    var requiresOnline = Boolean(Number(e.target.value));

    var value = getBoundToValue(requiresOnline);
    setFieldValue("boundTo", value, true);
  };

  const getBoundToValue = (requiresOnline) => {
    if (requiresOnline) {
      return BoundTo.CombinedProductAndSerialNumber.displayName;
    }

    return BoundTo.UnitFamilyTypeVersion.displayName;
  };

  return (
    <>
      <legend>
        <div className="row">
          <div className="col-sm-7 text-left">
            <p className="text-uppercase">
              <strong>Product Info</strong>
            </p>
          </div>
          {canDefineLicense && disabled && (
            <div className="col-sm-3 text-right">
              <p>
                <a
                  style={{ fontSize: "12px", cursor: "pointer" }}
                  onClick={onEdit}
                >
                  <span className="glyphicon glyphicon-pencil" /> Edit
                </a>
              </p>
            </div>
          )}
        </div>
      </legend>
      <fieldset disabled={disabled}>
        <Input
          disabled={modalMode === FormMode.Edit ? true : disabled}
          col={6}
          label={{ col: 5, text: "Product Number" }}
          name="productNumber"
        />

        <Input
          col={6}
          label={{ col: 5, text: "Package Id" }}
          name="packageId"
        />

        <Input
          col={6}
          label={{ col: 5, text: "Package Name" }}
          name="packageName"
        />

        <MultilpleSelectAutoComplete
          col={6}
          label={{ col: 5, text: "Feature Id" }}
          name="featureIds"
          disabled={disabled}
          addNewOption={() => setShowNewFeatureModal(true)}
          options={featureOptions}
        />

        <Input col={6} label={{ col: 5, text: "Duration" }} name="duration" />

        <Input
          col={6}
          label={{ col: 5, text: "Number of Unlock" }}
          name="numberOfUnlock"
        />

        <SelectBoolean
          col={6}
          labelCol={5}
          name="requiresOnline"
          labelText="Requires Online"
          setFieldValueOf={setBoundToValue}
        />

        <InputArray
          col={6}
          name="requiredFirmwareVersions"
          label={{ col: 5, text: "Required Firmware Version" }}
        />

        <Input
          col={6}
          disabled
          label={{ col: 5, text: "Bound To" }}
          name="boundTo"
        />

        <Input
          col={6}
          disabled
          label={{ col: 5, text: "Product Type" }}
          name="productType"
        />

        <SelectUsageLimitType
          col={6}
          labelCol={5}
        />

        <Input
          col={6}
          label={{ col: 5, text: "Usage Limit" }}
          name="usageLimit"
        />

        <SelectBoolean
          col={6}
          labelCol={5}
          name="requiresLogin"
          labelText="Requires Login"
        />

        <Input
          col={6}
          disabled
          label={{ col: 5, text: "Signature Size" }}
          name="signatureSize"
        />
        <FeaturesModal
          path={"entitlement"}
          show={showNewFeatureModal}
          onHide={() => setShowNewFeatureModal(false)}
        />
      </fieldset>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    features: state.entitlement.features,
  };
};

export default connect(mapStateToProps, {
  GetFeatures,
})(ProductInfo);
